"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionStats = void 0;
/**
 * Stats class for tracking metrics per connection
 */
class ConnectionStats {
    constructor() {
        /**
         * Last n records of how long between REQ->EOSE
         */
        this.Latency = [];
        /**
         * Total number of REQ's sent on this connection
         */
        this.Subs = 0;
        /**
         * Count of REQ which took too long and where abandoned
         */
        this.SubsTimeout = 0;
        /**
         * Total number of EVENT messages received
         */
        this.EventsReceived = 0;
        /**
         * Total number of EVENT messages sent
         */
        this.EventsSent = 0;
        /**
         * Total number of times this connection was lost
         */
        this.Disconnects = 0;
    }
}
exports.ConnectionStats = ConnectionStats;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29ubmVjdGlvbi1zdGF0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25uZWN0aW9uLXN0YXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ0gsTUFBYSxlQUFlO0lBQTVCO1FBQ0U7O1dBRUc7UUFDSCxZQUFPLEdBQWEsRUFBRSxDQUFDO1FBRXZCOztXQUVHO1FBQ0gsU0FBSSxHQUFXLENBQUMsQ0FBQztRQUVqQjs7V0FFRztRQUNILGdCQUFXLEdBQVcsQ0FBQyxDQUFDO1FBRXhCOztXQUVHO1FBQ0gsbUJBQWMsR0FBVyxDQUFDLENBQUM7UUFFM0I7O1dBRUc7UUFDSCxlQUFVLEdBQVcsQ0FBQyxDQUFDO1FBRXZCOztXQUVHO1FBQ0gsZ0JBQVcsR0FBVyxDQUFDLENBQUM7SUFDMUIsQ0FBQztDQUFBO0FBOUJELDBDQThCQyJ9